<template>
  <section class="closefriend-hero " style="height: 100vh; overflow: hidden;">
    <div class="container-fluid h-100 p-0">
      <div class="row h-100 g-0">
        
        <!-- ======================== -->
        <!-- LEFT PANEL: Thread List  -->
        <!-- ======================== -->
        <div class="col-12 col-md-4 col-lg-3 h-100 flex-column chat-sidebar-panel"
             :class="(selectedSubscriber && selectedSubscriber.id) ? 'd-none d-md-flex' : 'd-flex'">
             
          <!-- Header & Search -->
          <div class="p-3 border-bottom border-white-10 chat-sidebar-header">
            <div class="d-flex align-items-center mb-3">
              <span class="cursor-pointer text-white me-3" @click="$router.push({ name: 'CreatorMessageDashboard', query: { tab: 'inbox' } })">
                <i class="fa fa-arrow-left"></i>
              </span>
              <h5 class="text-white font-weight-500 mb-0 me-2">Messages</h5>
              <span class="badge cursor-pointer me-2" 
                    style="background: linear-gradient(135deg, #ff6ec7, #f9a826);"
                    @click="toggleUnreadFilter"
                    title="Click to filter unread threads">
                {{ inboxCount }} Unread
              </span>
              <span v-if="unreadFilterActive" class="badge" style="background: rgba(229,59,185,0.15); border: 1px solid #E53BB9; border-radius: 20px; color: #E53BB9; cursor: pointer;" @click="clearUnreadFilter">
                Unread only <i class="fa fa-times ms-1"></i>
              </span>
            </div>
            <div class="position-relative">
              <i class="fa fa-search position-absolute text-muted" style="left: 12px; top: 12px;"></i>
              <input type="text" class="coloredInput w-100" style="padding-left: 36px; padding-top: 10px; padding-bottom: 10px; border-radius: 20px;" 
                     placeholder="Search subscribers..." v-model="searchQuery"
                     @keyup.enter="search(searchQuery)" @keyup="searchInput(searchQuery)">
              <span v-if="searchQuery" class="position-absolute cursor-pointer text-muted" style="right: 12px; top: 10px;" @click="clearSearch">&times;</span>
            </div>
          </div>

          <!-- Thread List -->
          <div class="flex-grow-1 overflow-auto" id="content">
            <div v-if="isInboxLoading" class="py-3">
              <div v-for="i in 5" :key="i" class="msg-inbox-row m-2 d-flex align-items-center mb-2" style="border-color: rgba(255,255,255,0.05); cursor: default;">
                <div class="me-3 flex-shrink-0" style="width: 44px; height: 44px; border-radius: 50%; background: rgba(255,255,255,0.05); animation: pulse 1.5s infinite;"></div>
                <div class="flex-grow-1">
                  <div style="height: 14px; background: rgba(255,255,255,0.08); width: 45%; border-radius: 4px; margin-bottom: 8px; animation: pulse 1.5s infinite;"></div>
                  <div style="height: 12px; background: rgba(255,255,255,0.04); width: 70%; border-radius: 4px; animation: pulse 1.5s infinite;"></div>
                </div>
              </div>
            </div>
            <div v-else-if="subscribers.length === 0" class="text-center py-5">
              <p class="text-muted font-size-14 mb-0">No records found</p>
            </div>
            <div v-else v-for="(subscriber, index) in displayedSubscribers" :key="index"
                 class="msg-inbox-row m-2 cursor-pointer"
                 :class="{ 'active': selectedSubscriber && selectedSubscriber.id === subscriber.id, 'unread-thread': isUnread(subscriber) && (!selectedSubscriber || selectedSubscriber.id !== subscriber.id) }"
                 @click="changeSubscriber(subscriber)">
                 <div class="d-flex align-items-center" style="min-width: 0;">
                    <div class="position-relative me-3 flex-shrink-0">
                      <message-avatar :user-id="subscriber.id"/>
                      <span v-if="isUnread(subscriber) && (!selectedSubscriber || selectedSubscriber.id !== subscriber.id)" class="msg-unread-dot-badge position-absolute"></span>
                    </div>
                    <div class="flex-grow-1" style="min-width: 0;">
                      <div class="d-flex align-items-center justify-content-between">
                        <span class="font-size-14 text-truncate" 
                              :class="(isUnread(subscriber) && (!selectedSubscriber || selectedSubscriber.id !== subscriber.id)) ? 'text-white font-weight-700' : 'text-white font-weight-500'" 
                              :title="subscriber.name || subscriber.email">
                          {{ subscriber.name || subscriber.email }}
                        </span>
                        <span class="font-size-12 ms-2 flex-shrink-0" 
                              :class="(isUnread(subscriber) && (!selectedSubscriber || selectedSubscriber.id !== subscriber.id)) ? 'text-white font-weight-600' : 'text-muted'" 
                              v-if="subscriber.lastChat">
                          {{ timeSince(subscriber.lastChat.sentAt) }}
                        </span>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mt-1" v-if="subscriber.lastChat">
                        <p class="font-size-12 mb-0 message-preview text-truncate" 
                           :class="(isUnread(subscriber) && (!selectedSubscriber || selectedSubscriber.id !== subscriber.id)) ? 'text-white font-weight-500' : 'text-muted'" 
                           :title="subscriber.lastChat.message"
                           :style="(isUnread(subscriber) && (!selectedSubscriber || selectedSubscriber.id !== subscriber.id)) ? 'opacity: 0.9;' : ''">
                           {{ cropMessage(subscriber.lastChat) }}
                        </p>
                        <span v-if="isUnread(subscriber) && (!selectedSubscriber || selectedSubscriber.id !== subscriber.id)" class="msg-unread-badge ms-2">
                          {{ (subscriber.unreadCount && subscriber.unreadCount > 0) ? subscriber.unreadCount : '1' }}
                        </span>
                      </div>
                    </div>
                 </div>
            </div>
          </div>
        </div>

        <!-- ======================== -->
        <!-- RIGHT PANEL: Chat Area   -->
        <!-- ======================== -->
        <div class="col-12 col-md-8 col-lg-9 h-100 flex-column chat-main-panel"
             :class="(selectedSubscriber && selectedSubscriber.id) ? 'd-flex' : 'd-none d-md-flex'">
          
          <template v-if="selectedSubscriber && selectedSubscriber.id">
            <!-- Chat Header -->
            <div class="p-3 border-bottom border-white-10 d-flex align-items-center justify-content-between chat-header-bar z-index-1">
              <div class="d-flex align-items-center">
                <span class="cursor-pointer text-white me-3 d-md-none" @click="$router.push({ name: 'CreatorMessageDashboard', query: { tab: 'inbox' } })">
                  <i class="fa fa-arrow-left"></i>
                </span>
                <message-avatar :user-id="selectedSubscriber.id" class="me-3"/>
                <div>
                  <h6 class="text-white font-weight-500 mb-0">{{ selectedSubscriber.name || selectedSubscriber.email || 'Conversation' }}</h6>
                </div>
              </div>
              <div class="d-flex align-items-center px-3 py-1" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 12px;">
                <span class="text-muted font-size-12 me-2">Total spent</span>
                <span class="text-white font-weight-600">${{ selectedSubscriber.spent || 0 }}</span>
              </div>
            </div>

            <!-- Chat Messages Area -->
            <div class="flex-grow-1 overflow-auto p-3 p-md-4" id="content">
              <!-- In-Panel Loading indicator -->
              <div v-if="isMessagesLoading && messages.length === 0" class="h-100 d-flex flex-column justify-content-center align-items-center py-5">
                <div class="stella-pulse-spinner mb-3">
                  <div class="stella-pulse-dot"></div>
                  <div class="stella-pulse-dot"></div>
                  <div class="stella-pulse-dot"></div>
                </div>
                <span class="text-muted font-size-12 mt-2" style="opacity: 0.7;">Loading conversation...</span>
              </div>
              <template v-else-if="messages.length === 0">
                <div class="h-100 d-flex flex-column align-items-center justify-content-center text-center py-5">
                  <div class="stella-empty-state-icon mb-3">
                    <i class="fa fa-comments font-size-28" style="opacity: 0.35; color: #E53BB9;"></i>
                  </div>
                  <h6 class="text-white font-weight-500 mb-1" style="opacity: 0.7;">No messages yet</h6>
                  <p class="text-muted font-size-13 mb-0">Say hello to start the conversation</p>
                </div>
              </template>
              <template v-else v-for="(message, index) in messages">
                <!-- Unread indicator -->
                <div v-if="!messages.slice(0, index).some(msg => !msg.read) && !message.read && selectedSubscriber && message.senderId === selectedSubscriber.id"
                     class="text-center my-3" :key="'unread-'+index">
                  <span class="badge" style="background: rgba(229, 59, 185, 0.2); color: #E53BB9;">{{ unreadMessagesCount }} Unread messages</span>
                </div>
                
                <div class="d-flex flex-column mb-3" :id="`message_${index}`" :key="message.id || index"
                     :class="(selectedSubscriber && message.senderId === selectedSubscriber.id) ? 'align-items-start' : 'align-items-end'">
                  
                  <div :class="(selectedSubscriber && message.senderId === selectedSubscriber.id) ? 'chat-bubble-subscriber' : 'chat-bubble-creator'"
                       :style="message.isHighlighted ? 'box-shadow: 0 0 10px #E53BB9;' : ''">
                    <span v-if="message.message" v-html="formatMessage(message.message)"></span>
                    
                    <template v-if="message.content && getUser && message.senderId === getUser.id">
                      <div class="mt-2 text-center w-100">
                        <img v-if="message.content.type === 'IMAGE'" @click="showMediaPreview($event, message.content)"
                             @load="handleMediaLoad"
                             :src="message.content.cdnUrl" alt="" class="chat-media-attachment cursor-pointer">
                        <video v-else-if="message.content.type === 'VIDEO'" @click="showMediaPreview($event, message.content)"
                               @loadeddata="handleMediaLoad"
                               oncontextmenu="return false;" controlsList="nodownload" controls :src="message.content.cdnUrl"
                               class="chat-media-attachment cursor-pointer">
                        </video>
                      </div>
                      <div v-if="message.locked" class="font-size-10 opacity-75 mt-1">
                        <i class="fa fa-lock me-1"></i>Not yet unlocked by subscriber
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>

            <!-- Chat Input Area -->
            <div class="p-3 border-top border-white-10 chat-input-bar z-index-1">
              <div class="d-flex align-items-end bg-dark-glass p-2 chat-input-container" style="border-radius: 24px;">
                <span class="cursor-pointer text-muted px-3 py-2" @click="$refs.uploadFile.show(selectedSubscriber ? selectedSubscriber.id : null, null)">
                  <i class="fa fa-paperclip font-size-18 hover-pink"></i>
                </span>
                
                <div class="flex-grow-1 text-white chat-input-editable mx-2 py-2" contenteditable="true"
                     @input="updateMessage" @keydown.enter="handleEnterKey" @paste="handlePaste"
                     placeholder="Type your message..."></div>
                
                <span class="cursor-pointer px-3 py-2" @click="sendMessage()">
                  <i class="fa fa-paper-plane font-size-18 pwa-gradient-icon"></i>
                </span>
              </div>
            </div>
          </template>
          
          <!-- Empty State (No subscriber selected on desktop) -->
          <div v-else class="h-100 d-flex flex-column align-items-center justify-content-center">
             <div class="stella-empty-state-icon mb-3">
               <i class="fa fa-comments font-size-32" style="opacity: 0.4; color: #E53BB9;"></i>
             </div>
             <h5 class="text-white font-weight-500 mb-2" style="opacity: 0.6;">Your Messages</h5>
             <p class="text-white font-size-14 mb-0" style="opacity: 0.35;">Select a conversation to start chatting</p>
          </div>
          
        </div>

      </div>
    </div>

    <upload-media ref="uploadFile" @messageSent="contentMessageSent" />
    <model-image-view ref="imageView" />
    <model-video-view ref="videoView" />
    <loading-modal :is-loading="isLoading" />
  </section>
</template>
<script>
import { httpMixin } from "@/mixin/http-mixin";
import { mapGetters } from "vuex";
import { SERVICE_CONTENT, SERVICE_DIRECT_MESSAGE } from "@/properties/micro-service";
import UploadMedia from "@/components/module/influencer/direct-message/UploadMedia";
import ModelImageView from "@/components/module/shared/ModelImageView";
import ModelVideoView from "@/components/module/shared/ModelVideoView";
import { CONTENT_TYPE_IMAGE, CONTENT_TYPE_VIDEO } from "@/properties/content-type";
import { cropMessage, scroll } from "@/common/Utils";
import InfluencerMenu from "@/components/module/influencer/shared/InfluencerMenu";
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import '@/assets/styles/direct-message/direct-message-common.css';
import { timeSince } from "@/common/datetime-service";
import MessageAvatar from "@/components/module/shared/direct-message/MessageAvatar";
import LoadingModal from "@/components/module/shared/LoadingModal";


export default {
  name: "CreatorDirectMessage",
  components: {
    MessageAvatar,
    UploadMedia,
    ModelImageView,
    ModelVideoView,
    LoadingModal,

    InfluencerMenu,
    HeaderMenu
  },
  mixins: [httpMixin],
  data() {
    const routeCustomerId = this.$route && this.$route.params && this.$route.params.customerId;
    const storedId = localStorage.getItem('selectedSubscriberId');
    const initialId = routeCustomerId ? parseInt(routeCustomerId) : (storedId ? parseInt(storedId) : null);

    return {
      searchQuery: '',
      subscribers: [],
      selectedSubscriber: initialId ? { id: initialId } : {},
      messages: [],
      draftMessage: null,
      pollInterval: null,
      showSlideBar: false,
      inboxCount: 0,
      unreadMessagesCount: 0,
      hasClearedSearch: true,
      isLoading: false,
      isInboxLoading: true,
      isMessagesLoading: !!initialId,
      unreadFilterActive: false,
      unreadSubscribers: [],
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    displayedSubscribers() {
      return this.unreadFilterActive ? this.unreadSubscribers : this.subscribers;
    }
  },
  watch: {
    displayedSubscribers(newList) {
      if (this.selectedSubscriber && this.selectedSubscriber.id && newList && newList.length > 0) {
        const found = newList.find(s => s.id == this.selectedSubscriber.id);
        if (found) {
          this.selectedSubscriber = { ...this.selectedSubscriber, ...found };
        }
      }
    },
    getUser: {
      immediate: true,
      handler(user) {
        if (user && user.id) {
          if (!this.subscribers || this.subscribers.length === 0) {
            this.getSubscribersLatestMessage();
          }
          if (this.selectedSubscriber && this.selectedSubscriber.id && (!this.messages || this.messages.length === 0)) {
            this.isMessagesLoading = true;
            this.getMessages(true);
          }
        }
      }
    }
  },
  created() {
    this.isInboxLoading = true;
    this.clearGlobalMessages();
    if (this.getUser && this.getUser.id) {
      this.getSubscribersLatestMessage();
      if (this.selectedSubscriber && this.selectedSubscriber.id) {
        this.isMessagesLoading = true;
        this.getMessages(true);
      }
    }
  },
  mounted() {
    this.pollInterval = setInterval(() => {
      if (typeof document !== 'undefined' && document.hidden) {
        return;
      }
      this.getMessages();
    }, 6000)
  },
  destroyed() {
    clearInterval(this.pollInterval);
    localStorage.removeItem('selectedSubscriberId');
  },
  methods: {
    cropMessage,
    timeSince,
    toggleUnreadFilter() {
      if (this.unreadFilterActive) {
        this.clearUnreadFilter();
        return;
      }
      if (!this.getUser || !this.getUser.id) return;
      this.unreadFilterActive = true;
      const url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}/latest/unread`;
      this.getData(url, (data) => {
        let lastChats = data.chatMessages || [];
        let users = data.users || [];
        let result = [];
        lastChats.forEach((lastChat) => {
          let index = users.findIndex(u => u.id === lastChat.senderId || u.id === lastChat.receiverId);
          if (index !== -1) {
            let sub = users[index];
            sub.lastChat = lastChat;
            sub.hasUnreadBuried = this.isUnread(sub);
            result.push(sub);
          }
        });
        this.unreadSubscribers = result;
      });
    },
    clearUnreadFilter() {
      this.unreadFilterActive = false;
      this.unreadSubscribers = [];
    },
    isUnread(subscriber) {
      if (!subscriber) return false;
      if (subscriber.hasUnreadBuried) return true;
      if (this.unreadFilterActive && this.unreadSubscribers && this.unreadSubscribers.some(u => u.id === subscriber.id)) return true;
      if (this.unreadSubscribers && this.unreadSubscribers.some(u => u.id === subscriber.id)) return true;
      const currentUserId = this.getUser ? this.getUser.id : null;
      return !!(subscriber.lastChat && (
        subscriber.lastChat.new ||
        (!subscriber.lastChat.read && subscriber.lastChat.senderId !== currentUserId)
      ));
    },
    getSubscribersLatestMessage() {
      if (!this.getUser || !this.getUser.id) {
        this.isInboxLoading = false;
        return;
      }
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}/latest`;
      this.getData(url, (lastChatData) => {
        this.isInboxLoading = false;
        let lastChats = lastChatData.chatMessages ? lastChatData.chatMessages : [];
        this.inboxCount = lastChatData.unreadMessageCount;
        let users = lastChatData.users ? lastChatData.users : [];
        this.subscribers = [];
        lastChats.forEach((lastChat) => {
          let index = users.findIndex(sub => sub.id === lastChat.senderId || sub.id === lastChat.receiverId);
          if (index !== -1) {
            let sub = users[index];
            sub.lastChat = lastChat;
            this.subscribers.push(sub);
          }
        });
        if (this.subscribers.length > 0) {
          let selectedIndex = 0;
          const storedSubscriberId = localStorage.getItem('selectedSubscriberId');

          if (this.$route.params.customerId) {
            selectedIndex = this.subscribers.findIndex((sub) => sub.id == this.$route.params.customerId);
            selectedIndex = selectedIndex === -1 ? 0 : selectedIndex;
          } else if (storedSubscriberId) {
            selectedIndex = this.subscribers.findIndex((sub) => sub.id === parseInt(storedSubscriberId));
            selectedIndex = selectedIndex === -1 ? 0 : selectedIndex;
          }
          const matchedSub = this.subscribers[selectedIndex];
          if (matchedSub) {
            this.selectedSubscriber = { ...this.selectedSubscriber, ...matchedSub };
            localStorage.setItem('selectedSubscriberId', String(matchedSub.id));
          }
          this.getMessages();
        }
      }, () => {
        this.isInboxLoading = false;
      }, true);
    },

    clearSearch() {
      if (!this.getUser || !this.getUser.id) return;
      this.hasClearedSearch = true;
      this.searchQuery = '';
      this.subscribers = [];
      if (this.messages) {
        this.messages.forEach(message => {
          message.isHighlighted = false;
        });
      }
      // this.getSubscribersLatestMessage();
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}/latest`;
      this.getData(url, (lastChatData) => {
        let lastChats = lastChatData.chatMessages ? lastChatData.chatMessages : [];
        this.inboxCount = lastChatData.unreadMessageCount;
        let users = lastChatData.users ? lastChatData.users : [];
        lastChats.forEach((lastChat) => {
          let index = users.findIndex(sub => sub.id === lastChat.senderId || sub.id === lastChat.receiverId);
          if (index !== -1) {
            let sub = users[index];
            sub.lastChat = lastChat;
            if (!sub.unreadCount) sub.unreadCount = 0;
            const currentUserId = this.getUser ? this.getUser.id : null;
            if (!lastChat.read && currentUserId && lastChat.senderId !== currentUserId) {
              sub.unreadCount = 1;
              this.fetchUnreadCountForThread(sub, this.subscribers.length);
            }
            this.subscribers.push(sub);
          }
        });
      });
    },
    search(searchQuery) {
      if (!this.getUser || !this.getUser.id) return;
      this.searchQuery = searchQuery;
      if (searchQuery.length < 3) {
        return;
      }
      if (searchQuery.length === 0) {
        return;
      }
      this.subscribers = [];
      this.isLoading = true;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}/latest?searchKey=${searchQuery}`;
      this.getData(url, (lastChatData) => {
        let lastChats = lastChatData.chatMessages ? lastChatData.chatMessages : [];
        this.inboxCount = lastChatData.unreadMessageCount;
        let users = lastChatData.users ? lastChatData.users : [];
        this.subscribers = [];
        lastChats.forEach((lastChat) => {
          let index = users.findIndex(sub => sub.id === lastChat.senderId || sub.id === lastChat.receiverId);
          if (index !== -1) {
            let sub = users[index];
            sub.lastChat = lastChat;
            this.subscribers.push(sub);
          }
        });
        
        // If current selected subscriber is not in the search results, clear the right panel
        if (this.selectedSubscriber && this.selectedSubscriber.id) {
          const found = this.subscribers.some(sub => sub.id === this.selectedSubscriber.id);
          if (!found) {
            this.selectedSubscriber = {};
            this.messages = [];
          }
        }
        
        if (this.messages) {
          this.messages.forEach(message => {
            const sanitizeString = str => str.replace(/\s+/g, ' ').trim();
            if (this.searchQuery) {
              const lowerCaseQuery = sanitizeString(this.searchQuery).toLowerCase();
              this.messages.forEach(message => {
                const lowerCaseMessage = sanitizeString(message.message || '').toLowerCase();
                message.isHighlighted = lowerCaseMessage.includes(lowerCaseQuery);
              });
            }
          });
        }
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      });
    },
    fetchUnreadCountForThread(subscriber, index) {
      if (!this.getUser || !this.getUser.id) return;
      const url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}/receiver/${subscriber.id}`;
      this.getData(url, (messages) => {
        const currentUserId = this.getUser ? this.getUser.id : null;
        const count = messages.filter(m => !m.read && m.senderId !== currentUserId).length;
        if (count > 0) {
          subscriber.unreadCount = count;
          this.$set(this.subscribers, index, subscriber);
        }
      });
    },
    contentMessageSent(message) {
      this.messages.push(message);
      this.scrollToMessage(this.messages.length - 1);
    },
    searchInput(searchQuery) {
      if (searchQuery.length === 0 && !this.hasClearedSearch) {
      this.clearSearch();
    } else if (searchQuery.length > 0) {
      this.hasClearedSearch = false;
    }
    },
    getMessages(isSubChanged) {
      let receiverId = this.selectedSubscriber ? this.selectedSubscriber.id : null;
      if (!receiverId || !this.getUser || !this.getUser.id) {
        this.isMessagesLoading = false;
        return;
      }
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}/receiver/${receiverId}`;
      this.getData(url, (messages) => {
        this.isMessagesLoading = false;
        if (this.messages.length !== messages.length || isSubChanged) {
          this.messages = messages;
          this.messages.forEach(message => {
            const sanitizeString = str => str.replace(/\s+/g, ' ').trim();
            if (this.searchQuery) {
              const lowerCaseQuery = sanitizeString(this.searchQuery).toLowerCase();
              this.messages.forEach(message => {
                const lowerCaseMessage = sanitizeString(message.message || '').toLowerCase();
                message.isHighlighted = lowerCaseMessage.includes(lowerCaseQuery);
              });
            }
          });
          this.handleScrollToMessage(!!isSubChanged);
          this.markAsRead();
        }
      }, () => {
        this.isMessagesLoading = false;
      }, true);
    },
    markAsRead() {
      if (!this.getUser || !this.getUser.id) return;
      let messageIds = this.messages.filter((msg) => msg.receiverId === this.getUser.id && !msg.read).map(e => e.id);
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}/read/${messageIds}`;
      if (messageIds.length > 0) {
        this.messages.forEach(m => {
          if (messageIds.includes(m.id)) {
            m.read = true;
          }
        });
        this.postData(url, {}, (data) => {
          this.subscribers.forEach(subscriber => {
            if (subscriber.lastChat) {
              if (subscriber.lastChat.read === false) {
                subscriber.lastChat.read = true;
              }
            }
          });
        }, null, true);
      }
    },
    changeSubscriber(subscriber) {
      if (!subscriber) return;
      this.selectedSubscriber = subscriber;
      localStorage.setItem('selectedSubscriberId', String(subscriber.id));
      this.messages = [];
      this.isMessagesLoading = true;
      this.getMessages(true, this.searchQuery);
    },
    sendMessage() {
      if (!this.draftMessage) return;
      if (!this.getUser || !this.getUser.id) return;
      if (!this.selectedSubscriber || !this.selectedSubscriber.id) return;
      
      const trimmedMessage = this.draftMessage
        .replace(/&nbsp;/g, ' ')
        .replace(/<br>/g, '')
        .trim();
      if (!trimmedMessage) return;

      this.draftMessage = this.draftMessage.replace(/^&nbsp;+/g, '');
      this.draftMessage = this.draftMessage.replace(/&nbsp;+$/g, '');

      this.draftMessage = this.draftMessage.replace(/&nbsp;/g, '');

      this.draftMessage = this.draftMessage.trim();

      if (!this.draftMessage) return;
      this.draftMessage = this.draftMessage.replace(/\n/g, '<br>');
      this.draftMessage = this.draftMessage.trim();

      while (this.draftMessage.startsWith('<br>')) {
        this.draftMessage = this.draftMessage.slice(4);
      }
      while (this.draftMessage.endsWith('<br>')) {
        this.draftMessage = this.draftMessage.slice(0, -4);
      }
      this.draftMessage = this.draftMessage.trim();

      if (!this.draftMessage || !this.draftMessage.trim()) return;

      let chatMessage = {
        "message": this.draftMessage,
        "senderId": this.getUser.id,
        "receiverId": this.selectedSubscriber.id,
        "contentId": null,
        "status": "S",
        "locked": false,
        "read": false
      }
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}`;
      this.postData(url, chatMessage, (message) => {
        this.messages.push(message);
        this.draftMessage = null;
        const div = this.$el.querySelector('.chat-input-editable');
        if (div) {
          div.innerHTML = '';
        }
        this.scrollToMessage(this.messages.length - 1);
      }, (errorResponse) => {
        // Handle backend error gracefully with Toast
        let errorMsg = "Failed to send message.";
        if (errorResponse && errorResponse.globalErrors && errorResponse.globalErrors.length > 0) {
          errorMsg = errorResponse.globalErrors[0].code || errorResponse.globalErrors[0].message;
        } else if (errorResponse && errorResponse.allErrors && errorResponse.allErrors.length > 0) {
          errorMsg = errorResponse.allErrors[0].code || errorResponse.allErrors[0].message;
        }
        this.pushGlobalError(errorMsg);
      });
    },
    handleMediaLoad() {
      this.handleScrollToMessage();
    },
    handleScrollToMessage(force = false) {
      const currentUserId = this.getUser ? this.getUser.id : null;
      const unreadMessages = this.messages.filter(message => !message.read && message.senderId !== currentUserId);
      this.unreadMessagesCount = unreadMessages.length;

      const chatContainer = this.$el && this.$el.querySelector('#content');
      if (chatContainer && !force) {
        const isNearBottom = chatContainer.scrollHeight - chatContainer.scrollTop - chatContainer.clientHeight < 150;
        if (!isNearBottom) {
          return;
        }
      }

      if (this.unreadMessagesCount > 0 && force) {
        let unreadIndex = this.messages.findIndex(message => !message.read && message.senderId !== currentUserId);
        this.scrollToMessage(unreadIndex, { block: "center" });
      } else {
        this.scrollToMessage(this.messages.length - 1);
      }
    },
    scrollToMessage(num, options = {}) {
      if (num === -1) {
        return;
      }
      this.$nextTick(() => {
        this.scroll(`message_${num}`, options);
      });
    },
    scroll,
    showMediaPreview(event, content) {
      if (!this.isMobile()) {
        event.preventDefault();
      }
      if (content.type === CONTENT_TYPE_IMAGE && content.cdnUrl) {
        this.$refs.imageView.show(content.cdnUrl);
      } else if (content.type === CONTENT_TYPE_VIDEO && content.cdnUrl) {
        this.$refs.videoView.show(content.cdnUrl);
      }
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    },
    formatMessage(message) {
      if (message) {
        const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])|(\b(www\.[\S]+))/gi;
        return message.replace(urlPattern, url => {
          const href = url.startsWith('www.') ? `http://${url}` : url;
          return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
        });
      } else {
        return 'N/A'
      }
    },
    handleEnterKey(event) {
      if (event.shiftKey) {
        return;
      } else {
        event.preventDefault();
        this.sendMessage();
      }
    },
    updateMessage(event) {
      const div = event.target;
      if (div) {
        const text = div.innerText ? div.innerText.replace(/\r\n/g, '\n') : '';
        this.draftMessage = text === '\n' ? '' : text;
      }
    },
    handlePaste(event) {
      event.preventDefault();
      const text = (event.clipboardData || window.clipboardData).getData('text/plain');
      document.execCommand('insertText', false, text);
    },
  }
}
</script>
<style scoped>
.overflow-class {
  overflow: hidden;
  height: 100vh !important;
}

@media only screen and (max-width: 767px) {
  .chat-input-textarea-class {

    height: 8vh;
    width: 100%;
    position: fixed;
    bottom: 0;
    overflow: auto;
    background: #000;
  }

  .unread-count {
    color: #ffdd57;
    padding: 10px 20px;
    border-radius: 20px;
    font-size: 16px;
    font-weight: bold;
    align-items: center;
    margin: auto;
  }

  .chat-width-fix {
    height: 4vh;
    width: 59% !important;
  }
}

@media only screen and (min-width:768px)and (max-width: 1024px) {
  .chat-input-textarea-class {

    height: 8vh;
    width: 85%;
    position: fixed;
    bottom: 0;
    overflow: auto;
    background: #000;
  }

  .unread-count {
    color: #ffdd57;
    padding: 10px 20px;
    border-radius: 20px;
    font-size: 16px;
    font-weight: bold;
    align-items: center;
    margin: auto;
  }

  .chat-width-fix {
    height: 4vh;
    width: 73% !important;
  }
}

@media only screen and (min-width: 1025px) {
  .chat-input-textarea-class {

    height: 8vh;
    width: 90%;
    position: fixed;
    bottom: 0;
    overflow: auto;
    background: #000;
  }

  .unread-count {
    color: #ffdd57;
    padding: 10px 20px;
    border-radius: 20px;
    font-size: 16px;
    font-weight: bold;
    align-items: center;
    margin: auto;
  }

  .chat-width-fix {
    height: 4vh;
    width: 73% !important;
  }
}

.left-side-class {
  position: absolute;
  top: 14vh;
  height: 86vh;
  left: 0rem !important;
  overflow: auto;
  margin-bottom: 0rem !important;
  padding-bottom: 1rem !important;
}

.right-side-class {
  position: absolute;
  top: 14vh;
  height: 86vh;
  right: 0rem !important;
  overflow: hidden;
}

/*-------------media query for chat-div-----------------------------*/

@media screen and (max-width: 576px) {
  .chat-header-creator {
    height: 12vh;
    position: relative;
    top: 0;
  }

  .chat-content-creator {
    overflow: auto;
    height: 63vh;
    position: relative;
    margin-top: 1rem;
  }


}

@media screen and (min-width: 576px) and (max-width: 768px) {

  .chat-header-creator {
    height: 15vh;
    position: relative;
    top: 0;
  }

  .chat-content-creator {
    overflow: auto;
    height: 60vh;
    position: relative;
    margin-top: 1rem;
  }

}

@media screen and (min-width: 768px) and (max-width: 992px) {

  .chat-header-creator {
    height: 15vh;
    position: relative;
    top: 0;
  }

  .chat-content-creator {
    overflow: auto;
    height: 60vh;
    position: relative;
    margin-top: 1rem;
  }
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
  .chat-header-creator {
    height: 15vh;
    position: relative;
    top: 0;
  }

  .chat-content-creator {
    overflow: auto;
    height: 60vh;
    position: relative;
    margin-top: 1rem;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1400px) {

  .chat-header-creator {
    height: 15vh;
    position: relative;
    top: 0;
  }

  .chat-content-creator {
    overflow: auto;
    height: 60vh;
    position: relative;
    margin-top: 1rem;
  }
}

@media screen and (min-width: 1400px) {
  .chat-header-creator {
    height: 15vh;
    position: relative;
    top: 0;
  }

  .chat-content-creator {
    overflow: auto;
    height: 60vh;
    position: relative;
    margin-top: 1rem;
  }
}

.video-class {
  width: 240px !important;
  height: 220px !important;
}

a {
  color: #007bff;
  text-decoration: underline;
}

a:hover {
  color: #0056b3;
}

.custom-div {
  resize: none;
  overflow: hidden;
  /*min-height: 40px;*/
  min-height: 45px;
  max-height: 200px;
  box-sizing: border-box;
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 50px;
  background-color: #333;
  color: white;
  width: 100%;
  font-size: 16px;
  font-family: inherit;
  line-height: 1.5;
  overflow-wrap: break-word;
}

.r-padding {
  padding: 0px !important;
}

.input-wrapper {
  position: relative;
  width: 100%;
}

.input-class {
  /*padding-right: 30px !important;*/
  width: 100% !important;
  background: #333 !important;
  padding: 8px 10px !important;
  border-radius: 8px;
  color: #fff !important;
  border: 1px solid #fff;
  border: 3px solid transparent;
  /* Adjust the width as needed */
  /*border-radius: 4px; !* Optional: Adjust to your preference *!*/
  background-image: linear-gradient(#fff 0%, #fff 0%), linear-gradient(42deg, #F3DA6B, #E53BB9);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.clear-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 22px;
  color: #ccc;
  visibility: hidden;
  /* Hide by default */
}

.input-class:not(:placeholder-shown)~.clear-icon {
  visibility: visible;
  /* Show when there's text */
}


.tooltip {
  visibility: hidden;
  width: 150px;
  /* Set your desired width */
  background-color: #fff;
  color: #000;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  z-index: 1000;
  bottom: -130%;
  /* Position above the input */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  font-weight: 500 !important;
}

/* Show the tooltip on hover, but not when input is focused */
.input-wrapper:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.input-class:focus+.tooltip {
  visibility: hidden;
  opacity: 0;
}

.highlighted {
  background-color: yellow;
  /* Example highlight color */
  font-weight: bold;
  color: black;
}
.clicked{
  border: 2px solid transparent !important;
  background-image: linear-gradient(#fff, #fff 0), linear-gradient(90deg, #36d1dc, #5b86e5) !important; /* New gradient */
}

/* --- NEW CLEAN UI STYLES --- */
.bg-dark-transparent {
    background: rgba(17, 17, 17, 0.95);
}

.bg-dark-glass {
    background: rgba(255, 255, 255, 0.05);
}

.border-white-10 {
    border-color: rgba(255, 255, 255, 0.1) !important;
}

.msg-inbox-row {
    padding: 12px;
    border-radius: 12px;
    transition: all 0.2s ease;
    background: transparent;
}

.msg-inbox-row:hover {
    background: rgba(255, 255, 255, 0.05);
}

.msg-inbox-row.active {
    background: rgba(255, 255, 255, 0.08);
    box-shadow: inset 3px 0 0 #E53BB9;
}

.msg-inbox-row.unread-thread {
    background: rgba(229, 59, 185, 0.08) !important;
    border: 1px solid rgba(229, 59, 185, 0.3) !important;
    box-shadow: inset 3px 0 0 #E53BB9;
}

.msg-unread-dot-badge {
    top: -2px;
    right: -2px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: linear-gradient(135deg, #F3DA6B, #E53BB9);
    border: 2px solid #111;
    box-shadow: 0 0 6px rgba(229, 59, 185, 0.8);
}

.msg-new-badge {
    background: #55EFC4;
    color: #000;
    padding: 2px 6px;
    font-size: 10px;
    font-weight: 600;
    border-radius: 4px;
}

.msg-unread-badge {
    background: linear-gradient(135deg, #E53BB9, #ff6ec7);
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 12px;
    min-width: 20px;
    text-align: center;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(229, 59, 185, 0.4);
}

.msg-unread-dot {
    width: 8px;
    height: 8px;
    background: #E53BB9;
    border-radius: 50%;
    display: inline-block;
}

.chat-bubble-subscriber {
    background: #2A2A2A;
    color: white;
    padding: 12px 16px;
    border-radius: 16px 16px 16px 4px;
    max-width: 75%;
    font-size: 14px;
    line-height: 1.5;
    word-break: break-word;
}

.chat-bubble-creator {
    background: linear-gradient(135deg, #F3DA6B 0%, #E53BB9 100%);
    color: white;
    padding: 12px 16px;
    border-radius: 16px 16px 4px 16px;
    max-width: 75%;
    font-size: 14px;
    line-height: 1.5;
    word-break: break-word;
}

.chat-media-attachment {
    width: 220px;
    height: 220px;
    object-fit: cover;
    border-radius: 12px;
}

.chat-input-editable {
    min-height: 24px;
    max-height: 120px;
    overflow-y: auto;
    outline: none;
    line-height: 1.5;
    word-break: break-word;
    font-size: 14px;
}

.chat-input-editable:empty:before {
    content: attr(placeholder);
    color: rgba(255, 255, 255, 0.4);
    pointer-events: none;
}

.hover-pink {
    transition: color 0.2s ease;
}

.hover-pink:hover {
    color: #E53BB9 !important;
}

.stella-empty-state-icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: rgba(229, 59, 185, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
}

.z-index-1 {
    z-index: 1;
}

</style>
